"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getComponentDataAttributes = void 0;
var _isDefined = require("b2b-components/utils/isDefined");
const DATA_KEY = 'data-';
const getComponentDataAttributes = dataAttributes => {
  if (dataAttributes) {
    return Object.keys(dataAttributes).reduce((attributes, key) => {
      const attributeValue = dataAttributes[key];
      const validKey = key.toLowerCase();
      if ((0, _isDefined.isNotDefined)(attributeValue)) {
        return attributes;
      }
      if (validKey.startsWith(DATA_KEY)) {
        attributes[validKey] = attributeValue;
      } else {
        attributes[`${DATA_KEY}${validKey}`] = attributeValue;
      }
      return attributes;
    }, {});
  }
  return {};
};
exports.getComponentDataAttributes = getComponentDataAttributes;
//# sourceMappingURL=getComponentDataAttributes.js.map